import { createSlice, PayloadAction, createSelector } from '@reduxjs/toolkit';

export interface TenantState {
  currentTenantId: string | null;
  currentSalonId: string | null;
  tenants: Array<{
    id: string;
    salonId: string;
    name: string;
    subscriptionTier: string;
  }>;
  loading: boolean;
  error: string | null;
}

const defaultTenantId = import.meta.env.VITE_TENANT_ID || null;

const initialState: TenantState = {
  currentTenantId: localStorage.getItem('tenantId') || defaultTenantId,
  currentSalonId: localStorage.getItem('salonId'),
  tenants: [],
  loading: false,
  error: null,
};

const tenantSlice = createSlice({
  name: 'tenant',
  initialState,
  reducers: {
    setCurrentTenant: (state, action: PayloadAction<{ tenantId: string; salonId: string }>) => {
      state.currentTenantId = action.payload.tenantId;
      state.currentSalonId = action.payload.salonId;
      localStorage.setItem('tenantId', action.payload.tenantId);
      localStorage.setItem('salonId', action.payload.salonId);
    },
    setTenants: (state, action: PayloadAction<TenantState['tenants']>) => {
      state.tenants = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    clearTenant: (state) => {
      state.currentTenantId = null;
      state.currentSalonId = null;
      state.tenants = [];
      localStorage.removeItem('tenantId');
      localStorage.removeItem('salonId');
    },
  },
});

export const { setCurrentTenant, setTenants, setLoading, setError, clearTenant } =
  tenantSlice.actions;

export default tenantSlice.reducer;

// Selectors
export const selectCurrentTenantId = (state: any) => state.tenant.currentTenantId;
export const selectCurrentSalonId = (state: any) => state.tenant.currentSalonId;
export const selectCurrentTenant = createSelector(
  [selectCurrentTenantId, selectCurrentSalonId],
  (tenantId, salonId) => ({
    tenantId,
    salonId,
  })
);
export const selectTenants = (state: any) => state.tenant.tenants;
export const selectTenantLoading = (state: any) => state.tenant.loading;
export const selectTenantError = (state: any) => state.tenant.error;
